export default __webpack_public_path__ + "static/media/MaevaAydin.f5dadbba.png";